module.exports = __webpack_public_path__ + "static/media/meawwlogo.3290e666.svg";